export default __webpack_public_path__ + "static/media/vehicle.62ef0be0.png";